import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SEO from '../components/common/SEO';
import { projectsAPI } from '../utils/api';
import ProjectDetail from '../components/portfolio/ProjectDetail';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';

const ProjectDetailPage = () => {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [prevProject, setPrevProject] = useState(null);
  const [nextProject, setNextProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch current project and all projects
        const [projectResponse, allProjectsResponse] = await Promise.all([
          projectsAPI.getBySlug(slug),
          projectsAPI.getAll(),
        ]);

        const currentProject = projectResponse.data.data;
        const projects = allProjectsResponse.data.data || [];

        setProject(currentProject);

        // Find prev/next projects
        const currentIndex = projects.findIndex((p) => p.slug === slug);
        if (currentIndex > 0) {
          setPrevProject(projects[currentIndex - 1]);
        } else {
          setPrevProject(null);
        }
        if (currentIndex < projects.length - 1) {
          setNextProject(projects[currentIndex + 1]);
        } else {
          setNextProject(null);
        }
      } catch (err) {
        setError(err.message || 'Failed to load project');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return <Loading fullScreen text="Loading project..." />;
  }

  if (error) {
    return (
      <div className="py-16 bg-bg-secondary min-h-screen">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <ErrorMessage message={error} />
        </div>
      </div>
    );
  }

  if (!project) {
    return <Navigate to="/portfolio" replace />;
  }

  return (
    <>
      <SEO
        title={`${project.title} - Portfolio | Confident Portraits`}
        description={project.description || `View ${project.title} project by Confident Portraits. Professional ${project.category} work.`}
        image={project.coverImage}
        url={`/portfolio/${project.slug}`}
        type="article"
      />
      <ProjectDetail
        project={project}
        prevProject={prevProject}
        nextProject={nextProject}
      />
    </>
  );
};

export default ProjectDetailPage;
